import { FC } from 'react'
import { Formik, Form } from 'formik'
import { DateRangePicker } from 'react-date-range'
import Select from 'react-select'
import moment from 'moment'
import { useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { setFilter } from '../../redux/FilterSlice'
import { useAuth } from '../../modules/auth'

const customStyles = {
  control: (base: any) => ({
    ...base,
    border: '1px solid #e4e6ef',
    boxShadow: 'none',
    cursor: 'pointer',
    background: '#fff',
    height: '40px',
    width: '100%',
  }),
}

const DateRanger: FC = () => {
  const currentUser = useAuth()
  const options = currentUser.currentUser?.user?.customers?.map((customer: any) => ({
    value: customer?.customer_id,
    label: customer?.customer_name,
  }))

  const location = useLocation()
  const dispatch = useDispatch()
  const today = moment().toDate()
  const { startDate, endDate, customers } = useSelector((state: any) => state.Filter.Filter)

  const initialDateRange = [
    {
      startDate: startDate || today,
      endDate: endDate || today,
      key: 'selection',
    },
  ]

  return (
    <Formik
      initialValues={{
        customer: customers || [],
        dateRange: initialDateRange,
      }}
      onSubmit={(values, { setSubmitting }) => {
        const filterData = {
          customers: values.customer,
          startDate: moment(values.dateRange[0].startDate).format('YYYY-MM-DD'),
          endDate: moment(values.dateRange[0].endDate).format('YYYY-MM-DD'),
          isFiltered: true,
        }
        dispatch(setFilter(filterData))
        setSubmitting(false)
      }}
    >
      {({ setFieldValue, values, resetForm, dirty }) => (
        <Form className="menu menu-sub menu-sub-dropdown mt-3" data-kt-menu="true">
          <div className="px-7 py-5">
            <div className="flex">
              <div className="row">
                {location.pathname.includes('/dashboard') && (
                  <>
                    <div className="col-sm-12 col-md-6">
                      <div className="min-w-350px mb-2">
                        <Select
                          options={options}
                          placeholder="Select Customers"
                          isMulti={false}
                          maxMenuHeight={250}
                          styles={customStyles}
                          closeMenuOnSelect={false}
                          value={
                            values.customer?.length
                              ? (options ?? []).find((opt) => values.customer.includes(opt.value))
                              : null
                          }
                          onChange={(selectedOption: { value: string; label: string } | null) =>
                            setFieldValue('customer', selectedOption ? [selectedOption.value] : [])
                          }
                        />
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div className="min-w-350px mb-2">
                        <button
                          style={{ width: '100%' }}
                          type="button"
                          className="btn btn-light btn-active-light-primary p-3"
                          data-kt-calendar="true"
                        >
                          <i className="bi bi-calendar"></i>
                          {moment(values.dateRange[0].startDate).format('MMM DD, YYYY')} -{' '}
                          {moment(values.dateRange[0].endDate).format('MMM DD, YYYY')}
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>

            <DateRangePicker
              onChange={(item: any) => {
                setFieldValue('dateRange', [item.selection])
              }}
              showSelectionPreview={true}
              maxDate={moment(today).toDate()}
              moveRangeOnFirstSelection={false}
              months={2}
              ranges={values.dateRange}
              direction="horizontal"
              inputRanges={[]}
            />

            <div className="d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-sm btn-light btn-active-light-primary me-2"
                data-kt-menu-dismiss="true"
                onClick={() => {
                  resetForm()
                  dispatch(
                    setFilter({
                      customers: [],
                      startDate: moment().format('YYYY-MM-DD'),
                      endDate: moment().format('YYYY-MM-DD'),
                      isFiltered: false,
                    })
                  )
                  setFieldValue('dateRange', [
                    {
                      startDate: moment().toDate(),
                      endDate: moment().toDate(),
                      key: 'selection',
                    },
                  ])
                  setFieldValue('customer', [])
                }}
              >
                Reset
              </button>

              <button type="submit" disabled={!dirty} className="btn btn-sm btn-danger" data-kt-menu-dismiss="true">
                Apply
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  )
}

export default DateRanger
